<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Edit District</h1>

            <!-- <span class="mainDescription"
              >Use this page to start from scratch and put your custom
              content</span
            > -->
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-districts' }">Back</router-link>
          </div>
          <!-- <ol class="breadcrumb">
            <li class="active">
              <span>Blank Page</span>
            </li>
          </ol> -->
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form class="text-start mx-auto" @submit.prevent="editDistrict">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">English Name</label>
                    <input type="text" class="form-control" placeholder="Enter English Name" v-model="name_en"
                      required />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="districtName">Arabic Name</label>
                    <input type="text" class="form-control" placeholder="Enter Arabic Name" v-model="name_ar"
                      required />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label>Select City</label>
                    <multiselect v-model="city_id" :options="cities" :multiple="false" :searchable="true" label="name"
                      track-by="id" placeholder="Select City"></multiselect>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import axios from "../../Axios";
export default {
  name: "EditDistrict",
  components: {
    Multiselect
  },
  data() {
    return {
      name_en: "",
      name_ar: "",
      city_id: null,
      cities: [],
    };
  },
  created() {
    this.fetchDistrict();
    this.fetchCity();
  },

  methods: {
    async fetchCity() {
      try {
        const response = await axios.get("/admin/admin/city/all");
        this.cities = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchDistrict() {
      try {
        const response = await axios.get(
          "/admin/admin/district/get?id=" + this.$route.params.id
        );
        console.log(response.data.data)
        this.name_en = response.data.data.name_en;
        this.name_ar = response.data.data.name_ar;
        this.city_id = response.data.data.city;
      } catch (error) {
        console.error(error);
      }
    },
    async editDistrict() {
      try {
        const formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append('name_en', this.name_en);
        formData.append('name_ar', this.name_ar);
        formData.append('city_id', this.city_id.id);

        const response = await axios.post("admin/admin/district/update", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        console.log(response.data);
        this.$router.push({ name: "all-districts" });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  /* Add a background color */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Add a shadow for better visibility */
  width: 100%;
  /* max-width: 500px; Optional: Max width for better responsiveness */
}

form>.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}
</style>
